import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import RegisterSuccessPanel from "../../components/Login/RegisterSuccess/RegisterSuccess";
import VerifyPhone from "../../components/Login/VerifyPhone/VerifyPhone";
import TwoFAPanel from "../../components/Login/TwoFAPanel/TwoFAPanel";
import LoginPanel from "../../components/Login/LoginPanel/LoginPanel";
import RegisterPage from "../Register/RegisterPage";
import ResetPassword from "../../components/Login/ResetPassword/ResetPassword";
import VerifyEmailHash from "../../components/Login/VerifyEmailHash/VerifyEmailHash";
import ChangePassword from "../../components/Login/ChangePassword/ChangePassword";
import AuthExaccLayout from "../../components/AuthExaccLayout/AuthExaccLayout";

function AuthRoute({ children }) {
  return <AuthExaccLayout>{children}</AuthExaccLayout>;
}

const Login = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/verify-phone": "Verify your phone",
      "/verify-email": "Verify your e-mail",
      "/mfa": "Enter your 2FA code",
      "/reset-password": "Reset your password",
      "/register": "Create your Exacc Account",
      "/": "Exacc Login",
    };
    document.title = titles[location.pathname] || "Exacc Login";
  }, [location.pathname]);

  return (
    <Routes>
      <Route path={`/register`} element={<RegisterPage />} />
      <Route
        path={`/reset-password`}
        element={
          <AuthRoute>
            <ResetPassword />
          </AuthRoute>
        }
      />
      <Route
        path={`/verify-email`}
        element={
          <AuthRoute>
            <RegisterSuccessPanel />
          </AuthRoute>
        }
      />
      <Route
        path={`/verify-phone`}
        element={
          <AuthRoute>
            <VerifyPhone />
          </AuthRoute>
        }
      />
      <Route
        path={`/mfa`}
        element={
          <AuthRoute>
            <TwoFAPanel />
          </AuthRoute>
        }
      />
      <Route path={`/0/en-au/exacc/verify`} element={<VerifyEmailHash />} />
      <Route path={`/0/en-au/olivs/verify`} element={<VerifyEmailHash />} />
      <Route
        path={`/0/en-au/exacc/forgotuserpassword`}
        element={
          <AuthRoute>
            <ChangePassword />
          </AuthRoute>
        }
      />
      <Route
        path={`/0/en-au/olivs/forgotuserpassword`}
        element={
          <AuthRoute>
            <ChangePassword />
          </AuthRoute>
        }
      />
      <Route
        path={`*`}
        element={
          <AuthRoute>
            <LoginPanel />
          </AuthRoute>
        }
      />
    </Routes>
  );
};

export default Login;
